var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Storage } from "../../../../lib/localstorege.service";
import { getEvent } from "../../../../services/societyWon.services";
import _ from "lodash";
import { betSlipVisibleSubject } from "../../../../store/betslip.store";
import { CouponEventRow } from "../../../societywon/components/event";
import { initialLeftMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { GameOperationsApi } from '../../subpages/gameOperations/game.operations.api';
import { modalServiceSubject } from '../../../../components/modal/modal';
import "../../../societywon/societyWon.css";
import { isMobileView } from "../../../../app";
import { useTranslation } from "react-i18next";
export var societywonEventIdMapping = {};
function SportsDetail(params) {
    var token = Storage.get('token');
    var t = useTranslation().t;
    var forceUpdate = useForceUpdate();
    var _a = useState(null), coupon = _a[0], setCoupon = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        initialLeftMenu(false);
        betSlipVisibleSubject.next(false);
        getCouponDetail(params.data);
        return function () { };
    }, []);
    var getCouponDetail = function (coupon) {
        var data = {
            page: 0,
            token: token,
            coupon_id: coupon.id,
        };
        if (coupon.id) {
            GameOperationsApi.iddiaDetail(data).then(function (result) {
                if (result.status) {
                    var eventList = result.data.cart_data.map(function (c) {
                        return c.event_id;
                    });
                    var uniqeEventId = _.uniq(eventList);
                    for (var _i = 0, uniqeEventId_1 = uniqeEventId; _i < uniqeEventId_1.length; _i++) {
                        var eventId = uniqeEventId_1[_i];
                        getEvent(eventId).then(function (event) {
                            if (event) {
                                societywonEventIdMapping[Number(event.eventId)] = event;
                                forceUpdate();
                            }
                        });
                    }
                    result.data.addtional_ratio = coupon.addtional_ratio;
                    result.data.profit = (Number(result.data.profit) * Number(coupon.coupon_quantity)) + (Number(result.data.multiply) * Number(coupon.coupon_quantity) * Number(coupon.addtional_ratio));
                    result.data.amount = Number(result.data.amount) * Number(coupon.coupon_quantity);
                    result.data.total_ratio = (Math.round(Number(result.data.total_ratio) * 100) / 100) + Number(result.data.addtional_ratio);
                    result.data.extraProfit = (Number(result.data.multiply) * Number(coupon.coupon_quantity) * Number(coupon.addtional_ratio));
                    setCoupon(result.data);
                    setLoading(false);
                }
                else {
                    modalServiceSubject.next({
                        title: "Hata!",
                        content: result.message,
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        timeout: 0
                    });
                }
            });
        }
    };
    if (loading && !coupon) {
        return (_jsx("div", __assign({ style: { padding: '1rem', marginTop: '2rem' } }, { children: _jsx("div", { id: "loader" }, void 0) }), void 0));
    }
    if (isMobileView) {
        return (_jsx(_Fragment, { children: coupon.cart_data && coupon.cart_data.map(function (row, rowKey) {
                var event = societywonEventIdMapping[Number(row.event_id)];
                return (_jsx(CouponEventRow, { row: row, event: event, post: coupon }, "CouponEventRow" + rowKey));
            }) }, void 0));
    }
    return (_jsxs("div", __assign({ className: "dataListEl-open" }, { children: [coupon.cart_data && coupon.cart_data.map(function (row, rowKey) {
                var event = societywonEventIdMapping[Number(row.event_id)];
                return (_jsx("div", __assign({ className: "bet-history-t-holder-hk-bc" }, { children: _jsx(CouponEventRow, { row: row, event: event, post: coupon }, void 0) }), "CouponEventRow" + rowKey));
            }), _jsx("div", { className: "bet-history-t-holder-hk-bc" }, void 0)] }), void 0));
}
export default SportsDetail;
